/**
 * View model constructor for social login
 */
app.registerConstructor("SocialStorageCommon", function () {
    const self = this;

	/**
	 * A generic entrance point for remote social storage handling.
	 * Developer should assign actual specific login logic to self.remoteRetrieveFileFunction
	 * on different environment.
	 *
	 * @param files A JSON array contains chosen files. Each item should have the follow fields: name, source, downloadLink, token(optional).
	 * @param remoteAction A PrimeFaces remote command function for server side handling
	 */
    this.doRemoteRetrieveFile = function (files, remoteAction) {
        remoteAction([
            { name: "files", value: JSON.stringify(files)}
        ]);
    };
}).createVM();
